import { render, staticRenderFns } from "./FormularioCatalogo.vue?vue&type=template&id=5a48c7ba&scoped=true"
import script from "./FormularioCatalogo.vue?vue&type=script&lang=js"
export * from "./FormularioCatalogo.vue?vue&type=script&lang=js"
import style0 from "./FormularioCatalogo.vue?vue&type=style&index=0&id=5a48c7ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48c7ba",
  null
  
)

export default component.exports